import ProductDetailHero from './product-detail-hero';

export default ProductDetailHero;
